<template>
  <PageView
    class="validate full-page"
    :main-title="$t('validate-email.title')"
    :no-sub-title-expected="true"
  >
    <ContentView>
      <b-message v-show="!loading && !emailValidated" type="is-danger">
        {{ $t("validate-email.ko") }}
      </b-message>

      <b-message v-show="!loading && emailValidated && requireValidation" type="is-warning">
        {{ $t("validate-email.require-validation") }}
      </b-message>

      <b-message v-show="loading" type="is-info">
        {{ $t("validate-email.loading") }}
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      </b-message>
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { BMessage } from "buefy"

import { LoginService } from "@/services/rest/login/LoginService"
import { defineComponent } from "vue"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import { InfoReportingService } from "@/services/log/InfoReportingService"

export default defineComponent({
  name: "ValidateEmailPage",
  components: {
    PageView,
    ContentView,
    BMessage,
  },
  props: {
    validationToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loginService: LoginService.INSTANCE,
      infoReportingService: InfoReportingService.INSTANCE,
      loading: true,
      emailValidated: false,
      requireValidation: false,
    }
  },
  mounted(): void {
    this.validateEmail()
  },
  methods: {
    async validateEmail(): Promise<void> {
      try {
        const user = await this.loginService.validateEmail(this.validationToken)
        this.emailValidated = true
        this.loading = false
        if (user.statutActivation != "ACTIF") {
          this.requireValidation = true
        } else {
          // Nothing to do: user already re-routed after succesfull login (see LoginService.loginSucceeded())
        }
      } catch (e: any) {
        this.emailValidated = false
        this.loading = false
      }
    },
  },
})
</script>

<style scoped>
.validate {
  margin-top: 100px;
}
</style>
